/**
 * Created by iamso on 23.07.2020.
 */

KnockoutPlayerView = cc.Node.extend({
    ctor: function (player) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.player = player;
        this.pos = player.player ? "left" : "right";

        this.createBg();
        this.createAvatar();
        this.createName();
        this.createBar();

        this.onResize();
    },

    isOpponent: function () {
        return !this.player.player;
    },

    createBg: function () {
        const bg = this.bg = new cleverapps.Spine(bundles.game.jsons[this.isOpponent() ? "rival_tournament_json" : "me_tournament_json"]);
        bg.setAnimation(0, "animation", true);
        this.setContentSize2(this.bg.getContentSize());
        this.addChild(bg);
        bg.setAlignment(cleverapps.styles.KnockoutPlayerView.bg);
    },

    createAvatar: function () {
        const styles = cleverapps.styles.KnockoutPlayerView.avatar;
        const slot = this.bg.getSlot("slot_portrait");
        const avatar = this.avatar = new cleverapps.UI.Avatar(this.player, {
            frame: bundles.game.frames[this.isOpponent() ? "rival_frame_png" : "me_frame_png"],
            padding: styles.padding
        });
        slot.addChild(avatar);
        avatar.setAlignment(styles);
    },

    createName: function () {
        const slot = this.bg.getSlot("slot_name");
        const name = cleverapps.UI.generateOnlyText(
            this.player.name, cleverapps.styles.FONTS[this.isOpponent() ? "PLAYER_RIVAL_TEXT" : "PLAYER_ME_TEXT"]
        );
        name.fitTo(slot.width, slot.height);
        slot.addChild(name);
        name.setAlignment(cleverapps.styles.KnockoutPlayerView.name);
    },

    createBar: function () {
        const slot = this.bg.getSlot("slot_progress_bar");
        const bar = this.bar = new ScaledProgressBar({
            progress: bundles.game.frames[this.isOpponent() ? "rival_bar_png" : "me_bar_png"],
            background: bundles.game.frames[this.isOpponent() ? "rival_bar_bg_png" : "me_bar_bg_png"],
            barText: { text: "%from%/%to%" }
        });
        slot.addChild(bar);
        bar.setAlignment(cleverapps.styles.KnockoutPlayerView.bar);

        bar.setGoal(Game.currentGame.totalItemsToSolve());
        bar.setLength(slot.width);
        bar.setPercentage(this.player.amount / Game.currentGame.totalItemsToSolve());

        const loup = new cc.Sprite(bundles.game.frames.loupe_png);
        bar.addChild(loup);
        loup.setAlignment(cleverapps.styles.KnockoutPlayerView.bar.loup);

        if (!this.isOpponent()) {
            cleverapps.aims.registerTarget("user_progress", bar);
        }
    },

    updateProgress: function () {
        this.bar.setPercentage(this.player.amount, {
            animated: true
        });
    },

    onResize: function () {
        this.setScale(cleverapps.styles.KnockoutPlayerView.scale[cleverapps.resolution.mode]);
    },

    runUserBehindAnimation: function () {},
    stopUserBehindAnimation: function () {}
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    PLAYER_ME_TEXT_COLOR: new cc.Color(54, 87, 143, 255),
    PLAYER_RIVAL_TEXT_COLOR: new cc.Color(114, 47, 113, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PLAYER_ME_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.PLAYER_ME_TEXT_COLOR
    },
    PLAYER_RIVAL_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.PLAYER_RIVAL_TEXT_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.KnockoutPlayerView, {
    scale: [0.8, 1, 1],

    bg: {
        x: { align: "center" },
        y: { align: "center" }
    },

    avatar: {
        x: { align: "center" },
        y: { align: "center" },
        padding: {
            left: 25,
            right: 25,
            top: 25,
            bottom: 25
        }
    },

    name: {
        x: { align: "center" }, 
        y: { align: "center" }
    },

    bar: {
        x: { align: "center" },
        y: { align: "center" },
        loup: {
            x: { align: "left", dx: -5 },
            y: { align: "center" }
        }
    }
});